const API_URL = 'https://api.jsrdigimarketing.com/api/contact';

export const submitContact = async (data) => {
  const res = await fetch(API_URL, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify(data),
  });
  return res.json();
};
